import {
  CloudSyncOutlined,
  ReloadOutlined,
  WarningOutlined,
} from "@ant-design/icons";
import { FC } from "react";
import "./index.css";

interface ProjectFlowViewStateOverlayProps {
  phaseLabel: string;
  status: "loading" | "error";
  onRetry?: () => void;
}

const ProjectFlowViewStateOverlay: FC<ProjectFlowViewStateOverlayProps> = ({
  phaseLabel,
  status,
  onRetry,
}) => {
  const isLoading = status === "loading";

  return (
    <div
      aria-live="assertive"
      className={`projectFlowViewState projectFlowViewState--${status}`}
      role={isLoading ? "status" : "alert"}
    >
      <div className="projectFlowViewState__panel">
        <div className="projectFlowViewState__icon" aria-hidden="true">
          {isLoading ? <CloudSyncOutlined /> : <WarningOutlined />}
        </div>
        <div className="projectFlowViewState__copy">
          <span>{isLoading ? "正在获取最新数据" : "数据暂不可用"}</span>
          <strong>
            {isLoading
              ? `正在同步${phaseLabel}最新任务`
              : `${phaseLabel}任务同步失败`}
          </strong>
          <p>
            {isLoading
              ? "同步期间任务操作已暂停，请稍候。"
              : "当前任务内容可能不是最新版本，请重新加载后再继续操作。"}
          </p>
        </div>
        {isLoading ? (
          <div className="projectFlowViewState__progress" aria-hidden="true">
            <i />
            <i />
            <i />
          </div>
        ) : (
          <button aria-label="重新加载" onClick={onRetry} type="button">
            <ReloadOutlined aria-hidden="true" />
            <span>重新加载</span>
          </button>
        )}
      </div>
    </div>
  );
};

export default ProjectFlowViewStateOverlay;
